import * as Moment from 'moment'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as RasaModal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Holidays from './holidays'

export interface Schedule {
  community_id: number,
  created: string,
  created_datetime: Moment.Moment,
  cutoff_offset: number,
  days: string,
  frequency: string,
  id: number,
  is_active: boolean,
  is_primary: boolean,
  months: string,
  name: string,
  time: string,
  updated: string,
  updated_datetime: Moment.Moment,
  weeks: string,
}

export interface Frequency {
  description: string,
  key: string,
}

export interface FrequencyUnit {
  key: string,
  name: string,
}

export interface SelectedFrequencyUnit {
  isActive: boolean,
  unit: FrequencyUnit,
}

export interface ScheduleViewState extends Sortable.SortableViewState, IsActive.FilterableState {
}

export interface WrappedViewState {
  view: ScheduleViewState
}

export interface FormFields {
  cutoff_offset?: number,
  days?: string,
  frequency?: string,
  id?: number,
  name?: string,
  time?: string,
  weeks?: string,
}

export const FormFieldNames = {
  CutoffOffset: 'cutoff_offset',
  Days: 'days',
  Frequency: 'frequency',
  ID: 'id',
  Name: 'name',
  Time: 'time',
  Weeks: 'weeks',
}

export type ScheduleState = Sortable.SortableData<Schedule>

export interface FullComponentState {
  data: ScheduleState,
  form: Form.State<FormFields>,
  holidays: Holidays.HolidaysState,
  modal: RasaModal.State<{}>,
  view: ScheduleViewState,
}

export interface WrappedState {
  schedules: FullComponentState,
}



// WEBPACK FOOTER //
// ./src/pages/schedules/types.ts